import React from "react"
import api from "src/api"
import {getPoints} from "../../../utils";
import moment from "moment/moment";

export function useGetIntervalSettings() {

  const [pointOptions, setPointOptions] = React.useState([])
  const [settingItems, setSettingItems] = React.useState([])

  const [isLoading, setIsLoading] = React.useState(false)
  const [pagination, setPagination] = React.useState(null)

  async function getIntervalSettings(page = 1, countOnPage = 20) {
    setIsLoading(true)
    try {
      const { data } = await api.get(`custom-intervals?page=${page}&countOnPage=${countOnPage}`)
      setSettingItems(data.items)
      setPagination({
        current: data.pagination.currentPage,
        pageSize: data.pagination.countOnPage,
        total: data.pagination.total,
      })

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  async function getPointsOptions() {
    const data = await getPoints()

    const options = data.map((item) => ({
      label: item.name,
      value: item.id,
    }))
    setPointOptions(options)
  }

  function handleTableChange(pagination) {
    getIntervalSettings(pagination.current, pagination.pageSize)
  }



  React.useEffect(() => {
    getPointsOptions()
    getIntervalSettings()
  }, [])

  return {
    options: { pointOptions },
    isLoading,
    settingItems,
    pagination,
    refetch: () => getIntervalSettings(),
    handleTableChange
  }
}

export function getFormattedItems(items, pointOptions) {
  let newItems = [];
  if(items.length > 0 && pointOptions.length > 0) {
    newItems = items.map((item) => {
      const pointsNames = []
      if(items.length)
        item.pointIds.forEach((id) => {
          pointsNames.push(pointOptions.find((el) => el.value === id).label)
        })


      return {
        key: item.id,
        id: item.id,
        date: moment(item.date).format("DD.MM.YYYY"),
        points: pointsNames.join(", "),
        intervals: item.intervals
      }
    })
  }


  return newItems
}


